(() => {
  if (window.f9CommerceReady) return;
  window.f9CommerceReady = true;
  const requests = new WeakMap();
  const activateDetail = (scope, button, focus = false) => {
    scope.querySelectorAll('[role="tab"]').forEach(tab => {
      const selected = tab === button;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
    });
    scope.querySelectorAll('[role="tabpanel"]').forEach(panel => { panel.hidden = panel.id !== button.getAttribute('aria-controls'); });
    if (focus) button.focus();
  };
  document.addEventListener('click', event => {
    const mediaButton = event.target.closest('[data-f9-media]');
    if (mediaButton) {
      const root = mediaButton.closest('[data-f9-product]');
      const template = document.getElementById(mediaButton.dataset.f9Media);
      if (!root || !template) return;
      root.querySelector('[data-f9-main-media]').replaceChildren(template.content.cloneNode(true));
      root.querySelectorAll('[data-f9-media]').forEach(button => button.setAttribute('aria-pressed', String(button === mediaButton)));
    }
    const detailButton = event.target.closest('[data-f9-detail]');
    if (detailButton) activateDetail(detailButton.closest('[data-f9-detail-tabs]'), detailButton);
  });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('[data-f9-detail]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const scope = tab.closest('[data-f9-detail-tabs]');
    const tabs = [...scope.querySelectorAll('[role="tab"]')];
    const i = tabs.indexOf(tab);
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (i + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    event.preventDefault();
    activateDetail(scope, tabs[next], true);
  });
  document.addEventListener('change', async event => {
    const input = event.target.closest('[data-f9-option-id]');
    if (!input) return;
    const root = input.closest('[data-f9-product]');
    if (!root) return;
    requests.get(root)?.abort();
    const controller = new AbortController();
    requests.set(root, controller);
    const values = [...root.querySelectorAll('[data-f9-option-id]:checked')].map(option => option.dataset.f9OptionId);
    const url = new URL(input.dataset.f9ProductUrl || root.dataset.productUrl, location.origin);
    if (url.origin !== location.origin) return;
    url.searchParams.set('section_id', root.dataset.sectionId);
    url.searchParams.set('option_values', values.join(','));
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    const quantity = root.querySelector('[name="quantity"]')?.value;
    const plan = root.querySelector('[name="selling_plan"]')?.value;
    const focusId = input.id;
    root.setAttribute('aria-busy', 'true');
    root.querySelector('[data-f9-add]')?.setAttribute('disabled', '');
    const variantInput = root.querySelector('[data-f9-variant-id]');
    if (variantInput) variantInput.disabled = true;
    const error = root.querySelector('[data-f9-product-error]');
    if (error) error.hidden = true;
    try {
      const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error(String(response.status));
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (controller.signal.aborted || requests.get(root) !== controller) return;
      const replacement = parsed.querySelector('[data-f9-product]');
      const content = replacement?.querySelector('[data-f9-product-content]');
      if (!content) throw new Error('Product section missing');
      content.querySelectorAll('noscript').forEach(node => node.remove());
      root.querySelector('[data-f9-product-content]').replaceWith(content);
      root.dataset.productUrl = replacement.dataset.productUrl;
      const newQuantity = root.querySelector('[name="quantity"]');
      if (newQuantity && quantity) {
        const minimum = Number(newQuantity.min) || 1, maximum = Number(newQuantity.max) || Infinity, increment = Number(newQuantity.step) || 1;
        newQuantity.value = Math.min(maximum, minimum + Math.max(0, Math.floor((Number(quantity) - minimum) / increment)) * increment);
      }
      const newPlan = root.querySelector('[name="selling_plan"]');
      if (newPlan && [...newPlan.options].some(option => option.value === plan)) newPlan.value = plan;
      document.getElementById(focusId)?.focus({ preventScroll: true });
      const selectedId = root.querySelector('[data-f9-variant-id]')?.value;
      const historyUrl = new URL(root.dataset.productUrl, location.origin);
      if (preview) historyUrl.searchParams.set('preview_theme_id', preview);
      if (selectedId) historyUrl.searchParams.set('variant', selectedId);
      else historyUrl.searchParams.set('option_values', values.join(','));
      history.replaceState({}, '', historyUrl);
    } catch (cause) {
      if (cause.name !== 'AbortError' && requests.get(root) === controller) {
        const message = root.querySelector('[data-f9-product-error]');
        if (message) message.hidden = false;
      }
    } finally {
      if (requests.get(root) === controller) root.removeAttribute('aria-busy');
    }
  });
  document.addEventListener('submit', event => {
    const root = event.target.closest('[data-f9-product]');
    if (root && (root.getAttribute('aria-busy') === 'true' || event.target.querySelector('[data-f9-variant-id]')?.disabled)) event.preventDefault();
  });
  document.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest('[role="tabpanel"]');
    const scope = panel?.closest('[data-f9-detail-tabs]');
    if (!scope) return;
    const tab = [...scope.querySelectorAll('[role="tab"]')].find(button => button.getAttribute('aria-controls') === panel.id);
    if (tab) activateDetail(scope, tab);
  });
})();
